









import { Component, Prop, Vue } from 'vue-property-decorator'
import { ENV } from '../environment'

@Component({
  components: {}
})
export default class extends Vue {
  @Prop({
    default: ''
  })
  label!: string

  @Prop({
    required: true
  })
  checked?: boolean

  public get highlightError(): boolean {
    return ENV.isDev
  }
}
